<ng-template #closeButtonTemplate>
  <ion-button fill="outline" size="small" class="close-assistant-btn"
    (click)="closeAssistant(); $event.stopPropagation()">
    <ion-icon name="close-outline"></ion-icon>
  </ion-button>
</ng-template>

<ng-container>
  <!-- Botón flotante solo cuando el chat está cerrado -->
  <div *ngIf="!showChat" class="chat-header-bar" (click)="showChatModal()">
    <span class="chat-header-bar-title">
      <ion-icon name="chatbubbles"></ion-icon>
      &nbsp;{{moovingAssistant?.name}} </span>
    <div class="d-flex align-items-center justify-content-end">
      <ng-container *ngTemplateOutlet="closeButtonTemplate"></ng-container>
      &nbsp;
      <ion-icon name="chevron-up-outline"></ion-icon>
    </div>

  </div>

  <!-- Chat modal desplegado -->
  <div *ngIf="showChat || chatHiding">
    <div class="chat-modal-backdrop" (click)="hideChat()"></div>
    <div class="chat-modal" [class.hide]="chatHiding" [class.fullscreen]="isFullscreen"
      [class.minimizing]="isMinimizing">

      <div class="chat-header-bar open" (click)="hideChat()">
        <span class="chat-header-bar-title">
          <ion-icon name="chatbubbles"></ion-icon>
          &nbsp;{{moovingAssistant?.name}} &nbsp;</span>
        @if (!isPage) {

        <div class="expand-btn">

          <ion-button fill="outline" size="small" class="create-conv-btn"
            (click)="createNewConversation(); $event.stopPropagation()" *ngIf="!isFullscreen">
            <ion-icon name="create-outline"></ion-icon>
          </ion-button>
          <ion-button fill="outline" size="small" (click)="toggleFullscreen($event)">
            <ion-icon [name]="isFullscreen ? 'contract-outline' : 'expand-outline'"></ion-icon>
          </ion-button>
          <ng-container *ngTemplateOutlet="closeButtonTemplate"></ng-container>

        </div>

        <ion-icon name="chevron-down-outline"></ion-icon>
        }
      </div>

      <div class="chat-modal-content d-flex" [class.fullscreen]="isFullscreen">
        <!-- Conversation history panel -->
        <div *ngIf="isFullscreen" class="conversation-history-panel" [class.hidden]="!showHistory">
          <div class="history-header d-flex align-items-center justify-content-between">
            <span>Historial</span>
            <ion-button fill="clear" size="small" (click)="toggleHistory()" class="toggle-history-btn">
              <ion-icon [name]="showHistory ? 'chevron-back-outline' : 'chevron-forward-outline'"></ion-icon>
            </ion-button>
          </div>
          <div class="history-content">

            <ion-button expand="block" class="new-conversation-btn mb-2" (click)="createNewConversation()">
              <ion-icon slot="start" name="add-circle-outline"></ion-icon>
              Iniciar Conversación
            </ion-button>


            <app-conversations-history (refreshConversations)="getConversationsByUserIdAndAssistantId();"
              [conversations]="conversations" (deleteConversations)="deleteConversation($event)"
              (openConversation)="getConversationById($event.id!)"></app-conversations-history>
          </div>
        </div>
        <!-- Botón flotante para mostrar el historial si está oculto -->
        <ion-button *ngIf="isFullscreen && !showHistory" fill="clear" class="show-history-fab"
          (click)="toggleHistory()">
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>

        <!-- Chat principal -->
        <div class="messages-area" [class.full]="isFullscreen && !showHistory">
          <div class="messages-content">
            @if (!messages || messages.length === 0) {
            <div class="h-100 d-flex justify-content-center align-items-center">
              <ion-chip color="medium">
                <ion-icon name="chatbubbles"></ion-icon>
                <ion-label color="dark">
                  {{moovingAssistant?.initialMessage}}
                </ion-label>
              </ion-chip>
            </div>
            } @else {
            <ng-container *ngFor="let message of messages">
              <div class="row"
                [ngClass]="{'justify-content-start': message.userId !== user?.id, 'justify-content-end': message.userId === user?.id}">
                <div class="card chat-bubble"
                  [ngClass]="{'sent': message.userId !== user?.id, 'received': message.userId === user?.id}">
                  <div class="bubble-content" [appSafeHtml]="message.text"></div>
                  <button class="copy-btn" [clipboard]="message.text" title="Copiar" type="button">
                    <ion-icon name="copy"></ion-icon>
                  </button>
                </div>
              </div>
            </ng-container>
            @if (showError) {
            <div class="d-flex justify-content-center mt-4">
              <ion-chip color="danger">
                <ion-icon name="warning"></ion-icon>
                <ion-label color="dark">Error al procesar la respuesta. Intente nuevamente más tarde.</ion-label>
              </ion-chip>
            </div>
            }

            <div class="d-flex justify-content-center mt-4" *ngIf="loading">
              <ion-chip class="loading-message">
                <!-- <ion-spinner color="tertiary" name="lines"></ion-spinner> -->

                <span>{{loadingMessage}}</span>
              </ion-chip>
            </div>

            }
            <div #bottom></div>
          </div>
          <div class="message-input-container">
            <ion-toolbar>
              <div class="w-100">
                <ion-item class="py-2" lines="none">
                  <ion-input *ngIf="!isRecording" fill="outline" [(ngModel)]="messageInput" (keydown.enter)="sendMessage()"
                    placeholder="Escriba su pregunta">
                  </ion-input>
                  <ion-button *ngIf="messageInput && !isRecording" (click)="sendMessage()" size="large" color="secondary" slot="end">
                    <ion-icon slot="icon-only" name="send"></ion-icon>
                  </ion-button>
                  <ion-button *ngIf="!messageInput || isRecording" (mousedown)="startRecording()" (mouseup)="stopRecording()"
                    (mouseleave)="stopRecording()" size="large" color="secondary" slot="end">
                    <ion-icon slot="icon-only" name="mic-outline"></ion-icon>
                  </ion-button>
                  <voice-activity-indicator class="w-100" *ngIf="isRecording"  [active]="isRecording"></voice-activity-indicator>
                </ion-item>
              </div>
            </ion-toolbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>